import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    import("@lottiefiles/lottie-player");
  }
}
